<template>
    <div class="card">
        <div class="card-header" ref="jobList" id="jobList">
            <div class="col-md-12">
                <h4><i class="fa fa-edit"></i> {{'Job List '|trans}}
                    <RouterLink to="new_job" class="pull-right btn btn-default">
                        <i class="icon fa fa-plus-circle">️&zwnj;</i>
                        <span class="title"> {{ 'New Job' | trans }} </span>
                    </RouterLink>
                </h4>
            </div>
        </div>
        <spinner v-if="isLoading"></spinner>
        <spinner v-if="isCancellingJob" :title="'Cancelling Job'|trans"></spinner>

        <div v-if="!isLoading" class="row card-body table-responsive" id="new-job-form">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <td>{{'actions'|trans}}</td>
                        <td>{{'job'|trans}}</td>
                        <td>{{'customer'|trans}}</td>
                        <td>{{'state'|trans}}</td>
                        <td width="10%" >{{'description'|trans}}</td>
                        <td>{{'address'|trans}}</td>
                        <td>{{'phone'|trans}}</td>
                        <td>{{'email'|trans}}</td>
                        <td>{{'required time'|trans}}</td>
                        <td>{{'created_at'|trans}}</td>
                        <td>{{'date_job_start'|trans}}</td>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="job in jobs">
                    <td>
                        <RouterLink :to="{ name: 'edit_job', params: { jobId: job.id }}" class="btn btn-default btn-sm">
                            <i class="fa fa-edit"></i>
                        </RouterLink>
                        <RouterLink :to="{ name: 'add_job', params: { jobId: job.id }}" class="btn btn-default btn-sm">
                            <i class="fa fa-plus"></i>
                        </RouterLink>
                        <button class="btn btn-default btn-sm" @click="cancelJob(job.id)"><i class="fa fa-trash"></i> </button>
                    </td>
                    <td>
                        {{job.id|TruncateJobNumber}}
                    </td>
                    <td>
                        {{job.customer.lastname}}
                    </td>
                    <td>
                        <i class="fa fa-circle" :style="{color:stateColorizer(job.job_status)}"></i>
                    </td>
                    <td>
                        {{job.job_description}}
                    </td>
                    <td>
                        {{job.customer_address_intervention.street}}
                        {{ job.customer_address_intervention.number}}
                        {{ job.customer_address_intervention.zone.zip}} -
                        {{ job.customer_address_intervention.zone.commune_name}}
                    </td>
                    <td>
                        <a :href="`tel:${job.customer_address_intervention.customer.phones[0].phone_number}`">{{job.customer_address_intervention.customer.phones[0].phone_number}}
                        </a>
                    </td>
                    <td>
                        {{job.customer.email}}
                    </td>
                    <td>
                        {{job.job_time_required}}m
                    </td>
                    <td>
                        {{job.date_add|DateFormat('Y-MM-DD H:mm')}}
                    </td>
                    <td>
                        {{job.date_job_start|fDate }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

	import Spinner from "../Spinner";
	import Vue from "vue";
	import moment from "moment-timezone";
	export default {
		components: {
			Spinner
		},
		props: {
			user: Object
		},
		data: function () {
			return {
				isLoading:true,
                isCancellingJob:false,
				jobs : [],
			};
		},
        async created() {
			await this.getJobsOfWorkerOwner();
			this.isLoading = false;
		},
		methods: {
            async getJobsOfWorkerOwner(){
				this.jobs = await this.$api.job.getJobsOfWorkerOwner();
            },
			async cancelJob(jobId){
            	this.isCancellingJob = true;
				await this.$api.job.jobCancelForWorkerOwner(jobId);
				//Refresh Jobs
				await this.getJobsOfWorkerOwner();
				this.isCancellingJob = false;
			},
			stateColorizer(value){
            	if(value==='0'){
					return '#db5538';
                }
				return '#91bd20';
			}
		},
        filters:{
			TruncateJobNumber(value) {
				return value.toString().substr(2, value.toString().length);
			},
            fDate(date){
				return moment(date).format('Y-MM-DD H:mm');
            }
        }
	}
</script>

